import axiosInstance from '../services/AxiosInstance';

export function getOwnershipTypes(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`ownership-type?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function deleteOwnershipType(id) {
    return axiosInstance.delete(`ownership-type/${id}`);
}

export function createOwnershipType(id) {
    return axiosInstance.post(`ownership-type`,id);
}

export function updateOwnershipType(id, data) {
    return axiosInstance.put(`ownership-type/${id}`,data);
}
